export default __webpack_public_path__ + "static/media/fw-isabella-er-White Gold.748af65c.mp4";